import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetPlan, GetPlanModel, GetPlansParams} from 'domain/usecases/others/selection-flow/plan-v3';

export class RemoteGetPlan implements GetPlan {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetPlanModel>,
	) {}

	async get({signal}: GetPlansParams): Promise<GetPlanModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
